import React from "react";
import { fetchPortfolioAtGlance } from "../../store/reducers/dashboardSlice/api";
import {
  gridColumns_PortfolioAtGlance,
  gridColumns_PortfolioAtGlanceBroker,
  gridColumns_PortfolioAtGlanceNew,
} from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import useFetchTableData from "../../useFetchTableData";
import { useSelector } from "react-redux";
import { roleType } from "../../Utils/constant";
const portfolioFilter = [
  { name: "Principal Amount", key: "principal", type: "range" },
  { name: "Next Due Date", key: "next_due_date", type: "date" },
  { name: "Next Due Date", key: "next_due_date", type: "month" },
];

const PortfolioAtAGlanceTable = ({
  className = "",
  fetchKey = fetchPortfolioAtGlance,
}) => {
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const { data, status, retry } = useFetchTableData(fetchKey, "portfolioAtGlance");

  return (
    <CommonGrid
      status={status}
      onRetry={retry}
      className={`portfolio-at-glance col-sm-6 ${className}`}
      title={"Portfolio at a Glance"}
      // gridColumns={
      //   selectedRole === roleType.broker
      //     ? gridColumns_PortfolioAtGlanceBroker
      //     : gridColumns_PortfolioAtGlance
      // }
      gridColumns={
        selectedRole === roleType.broker
          ? gridColumns_PortfolioAtGlanceBroker
          : gridColumns_PortfolioAtGlanceNew
      }
      columnData={data}
      filterOption={portfolioFilter}
      tableTotal={["principal"]}
      showLegends={true}
      isDifferent={true}
    />
  );
};

export default PortfolioAtAGlanceTable;
